import React from "react";
import icon from "../assets/gallery.png";

interface props {
  url: any;
}

const Icon: React.FC<props> = ({ url }) => {
  return (
    <>
      <div className=" w-[70px] h-[70px] bg-[#77adff52]  border-[#c6bcffa4] border-2 rounded-[50%] w-[50px] h-[50px] flex justify-center items-center">
        <img src={url} width={50} height={50}></img>
      </div>
    </>
  );
};

export default Icon;
